import {MainUtils} from '@/utils/main-utils';

export const RouterUtils = {
  mixins: [
    MainUtils
  ],
  methods: {
    getRouter () {
      return this.$router;
    },

    pushToRoute (route, params, query) {
      if (!this.isCurrentRoute(route, params)) {
        this.getRouter().push({
          name: route,
          params: params,
          query: query
        });
      }
    },

    replaceToRoute (route, params, query) {
      if (!this.isCurrentRoute(route, params)) {
        this.getRouter().replace({
          name: route,
          params: params,
          query: query
        });
      }
    },

    gotoLandingPage () {
      if (this.hasAnyPermission('BOOKING_VIEW_DETAILS')) {
        this.replaceToRoute('Dashboard');
      } else if (this.hasAnyPermission('SETTLEMENT_VIEW')) {
        this.replaceToRoute('Settlements');
      } else if (this.hasAnyPermission('USER_VIEW')) {
        this.replaceToRoute('Users');
      } else if(this.hasAnyPermission('BOOKING_INDEX')) {
        this.replaceToRoute('Bookings');
      } else if(this.hasAnyPermission('SURVEY_VIEW')) {
        this.replaceToRoute('Surveys');
      } else {
        this.replaceToRoute('NotFound');
        console.warn('no start page to show');
      }
    },

    // setRootToRoute (route, params) {
    //   this.getRouter().navigate({
    //     name: route,
    //     params: params
    //   }, {
    //     props: params,
    //     clearPreviousHistory: true,
    //     reloadAll: true,
    //     animate: false
    //   });
    // },

    isFirstPage () {
      return window.history.length <= 1;
    },

    routerBack () {
      this.getRouter().back();
    },

    isCurrentRoute (route, params) {
      let router = this.getRouter();
      let sameParams = true;

      if(params !== undefined) {
        sameParams = JSON.stringify(params) === JSON.stringify(router.currentRoute.params);
      }
      return router.currentRoute && router.currentRoute.name === route && sameParams;
    },
  }
};
